import { SkinColorsEnum } from "../Types/SkinColors";

export const CharacterCreatorDefinition = {
    eyes: [
        164,
        166,
        160,
        146,
        130,
        140,
        144,
        152,
        133,
        131,
        121,
        135,
        148,
        150,
        125,
        132,
        158,
        149,
        129,
        147,
        // 153,
        // 165,
        // 151,
        // 154,
        // 167,
        // 145,
    ],
    faces: [
        51,
        42,
        47,
        48,
        57,
        64,
        55,
        63,
        59,
        41,
        43,
        56,
        62,
        49,
        46,
        54,
        53,
        50,
        60,
        44,
        45,
        39,
        58,
        52,
        40,
        61
    ],
    pupils: [
        253,
        248,
        246,
        251,
        252,
        247,
        249,
        250,
        255,
        254,
        243,
        264,
        242,
        244,
        245,
        259,
        296,
        235,
        261,
        260,
        295,
        297,
        299,
        301,
        298,
        300
    ],
    hairback: [
        278,
        19,
        82,
        22,
        31,
        80,
        28,
        101,
        20,
        35,
        21,
        75,
        76,
        69,
        37,
        32,
        26,
        70,
        71,
        73,
        23,
        25,
        24,
        30,
        29,
        72,
        67,
        27
    ],
    hairfront: [
        279,
        36,
        109,
        65,
        66,
        106,
        95,
        197,
        38,
        94,
        85,
        99,
        118,
        92,
        87,
        79,
        93,
        98,
        90,
        88,
        34,
        33,
        83,
        89,
        86,
        97,
        77,
        84
    ],
    mouths: [
        227,
        226,
        184,
        185,
        222,
        230,
        234,
        221,
        220,
        214,
        219,
        209,
        231,
        239,
        240,
        183,
        228,
        225,
        236,
        233,
        263,
        208,
        229,
        218,
        212,
        // 198,
        // 199,
        // 210
    ],
    noses: [
        224,
        205,
        217,
        192,
        173,
        232,
        190,
        191,
        174,
        194,
        177,
        223,
        204,
        178,
        // 172,
        213
    ],
    eyebrows: [
        179,
        143,
        122,
        155,
        162,
        141,
        169,
        157,
        180,
        119,
        181,
        159,
        156,
        196,
        171
    ],
    beards: [
        270,
        102,
        176,
        78,
        163,
        113,
        237,
        123,
        137,
        108,
        74,
        110,
        168,
        126
    ],
    hairtints: [
        0x4E433F,
        0x6A4E42,
        0x976950,
        0xA55728,
        0x8D4A43,
        0xFF0000,
        0xFFD700,
        0xFAF0BE,
        0xEEE9E9,
        0x0000FF,
        0x008000,
        0xFFC0CB,
        0x800080,
        0xC0C0C0,
        0xFFFFFF
    ],
    earFronts: [
        216,
        238,
        161,
        201,
        241,
        211,
        136,
        202,
        195,
        // 139,
        // 124,
        // 193,
        // 138,
        // 128
    ],
    skinColors: [
        0, 1, 2, 3, 4, 5, 6
    ]
};